<template>
  <v-container>
    <router-view></router-view>
  </v-container>
</template>
<script>
export default {
  name: 'contact',
  data() {
    return {}
  },
}
</script>
